export const fr = {
    common: {
        loading: 'Chargement…',
        save: 'Enregistrer',
        cancel: 'Annuler',
        close: 'Fermer',
        edit: 'Modifier',
        delete: 'Supprimer',
        confirm: 'Confirmer',
        search: 'Rechercher…',
        yes: 'Oui',
        no: 'Non',
    },
    auth: {
        login: 'Connexion',
        logout: 'Se déconnecter',
        email: 'Adresse courriel',
        password: 'Mot de passe',
        submit: 'Se connecter',
        tagline: 'Plateforme d\'intelligence territoriale municipale',
        forgotPassword: 'Mot de passe oublié ?',
        welcome: 'Bienvenue',
        welcomeBack: 'Ravi de vous revoir',
    },
    dashboard: {
        title: 'Tableau de bord',
        selectCity: 'Choisissez une ville',
        selectCityDescription: 'Sélectionnez la municipalité que vous souhaitez consulter.',
        noReports: 'Aucun signalement',
        noReportsDescription: 'Aucun signalement n\'a été créé pour cette ville.',
    },
    reports: {
        title: 'Signalements',
        new: 'Nouveau signalement',
        reference: 'Référence',
        priority: 'Priorité',
        status: 'Statut',
        category: 'Catégorie',
        types: 'Types de problème',
        createdAt: 'Créé le',
        resolvedAt: 'Résolu le',
        assignedTo: 'Assigné à',
        unassigned: 'Non assigné',
    },
};
//# sourceMappingURL=fr.js.map